import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.item.category && !_vm.miniVariant ? _c('div', {
    staticClass: "app-drawer-category",
    attrs: {
      "data-cy": _vm.item.category
    }
  }, [_vm._v("\n  " + _vm._s(_vm.i18nFromKey(_vm.item.category)) + "\n")]) : _vm.item.children && _vm.item.children.length > 1 ? _c(VListGroup, {
    key: _vm.item.text,
    class: _vm.miniVariant ? 'miniVariantIconGroup' : null,
    attrs: {
      "title": _vm.miniVariant ? _vm.i18nFromKey(_vm.item.text) : undefined
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c(VListItemAction, {
          class: _vm.miniVariant ? 'miniVariantIcon' : null
        }, [_c(VIcon, [_vm._v(_vm._s(_vm.item.icon))])], 1), _c(VListItemTitle, {
          attrs: {
            "data-cy": _vm.item.dataCy || _vm.item.text
          }
        }, [_vm.item.badge ? [_c(VBadge, {
          attrs: {
            "inline": "",
            "color": _vm.color,
            "icon": _vm.item.badge.icon,
            "offset-x": "25"
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function () {
              return [_c('span', {
                staticStyle: {
                  "color": "#fff"
                }
              }, [_vm._v(_vm._s(_vm.i18nFromKey(_vm.item.badge.content)))])];
            },
            proxy: true
          }], null, false, 2130638274)
        }, [_vm._v("\n          " + _vm._s(_vm.i18nFromKey(_vm.item.text)) + "\n        ")])] : [_vm._v("\n        " + _vm._s(_vm.i18nFromKey(_vm.item.text)) + "\n      ")]], 2)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.item.active,
      callback: function ($$v) {
        _vm.$set(_vm.item, "active", $$v);
      },
      expression: "item.active"
    }
  }, _vm._l(_vm.item.children, function (childItem, j) {
    return _c('core-drawer-item', {
      key: j,
      attrs: {
        "item": childItem
      }
    });
  }), 1) : _vm.item.children && _vm.item.children.length === 1 ? _c('core-drawer-item', {
    attrs: {
      "item": _vm.item.children[0]
    }
  }) : _vm.item.to ? _c(VListItem, {
    class: _vm.miniVariant ? 'v-list-item miniVariantLink' : 'v-list-item',
    attrs: {
      "to": !_vm.item.to.startsWith('http') ? _vm.item.to : undefined,
      "href": _vm.item.to.startsWith('http') ? _vm.item.to : undefined,
      "target": _vm.item.to.startsWith('http') ? '_blank' : undefined,
      "active-class": _vm.color,
      "title": _vm.miniVariant ? _vm.i18nFromKey(_vm.item.text) : undefined,
      "data-cy": _vm.item.dataCy || _vm.item.text
    }
  }, [_c(VListItemAction, {
    class: _vm.miniVariant ? 'miniVariantIcon' : null
  }, [_c(VIcon, [_vm._v(_vm._s(_vm.item.icon))])], 1), _c(VListItemTitle, [_vm.item.badge ? [_c(VBadge, {
    attrs: {
      "inline": "",
      "color": _vm.color,
      "icon": _vm.item.badge.icon,
      "offset-x": "25"
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function () {
        return [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_vm._v(_vm._s(_vm.i18nFromKey(_vm.item.badge.content)))])];
      },
      proxy: true
    }], null, false, 2130638274)
  }, [_vm._v("\n        " + _vm._s(_vm.i18nFromKey(_vm.item.text)) + "\n      ")])] : [_vm._v("\n      " + _vm._s(_vm.i18nFromKey(_vm.item.text)) + "\n    ")]], 2)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };